import { partial } from 'ramda';

import { ISelectOption } from 'components/shared/BaseFormComponents/Select/types';
import Button from 'components/shared/Button';
import Icon from 'components/shared/Icon';
import Visibility from 'components/shared/Icon/icons/Visibility';
import Text from 'components/shared/Typography/Text';

import s from './index.module.css';

type Props = {
  areaPage?: Pick<ISelectOption, 'id'> | null;

  onSubmit: (type: 'yes' | 'no' | 'choose-own') => void;
  onPagePreview: (id: ISelectOption['id']) => Promise<any>;
};

export const SuggestedAreaPromt = function ({ areaPage, onSubmit, onPagePreview }: Props) {
  return (
    <div>
      <div className={s.content}>
        <div className={s['main-data']}>
          <Text className={s.text} size="medium">
            Would you like to add the suggested area{'\n'}information for this accommodation?
          </Text>
        </div>

        <Icon
          disabled={!areaPage}
          className={s['icon-clickable']}
          component={Visibility}
          onClick={() => areaPage && onPagePreview(areaPage.id)}
        />
      </div>

      <div className={s.buttons}>
        <Button
          type="default"
          size="small"
          className={s.button}
          onClick={partial(onSubmit, ['yes'])}
          disabled={!areaPage}
        >
          Yes
        </Button>

        <Button type="default" size="small" className={s.button} onClick={partial(onSubmit, ['no'])}>
          No
        </Button>

        <Button
          type="default"
          size="small"
          className={s.button}
          style={{ flex: 2.5 }}
          onClick={partial(onSubmit, ['choose-own'])}
        >
          Choose My Own
        </Button>
      </div>
    </div>
  );
};
